import { render, staticRenderFns } from "./editRelevance.vue?vue&type=template&id=80109a7a&scoped=true&"
import script from "./editRelevance.vue?vue&type=script&lang=js&"
export * from "./editRelevance.vue?vue&type=script&lang=js&"
import style0 from "./editRelevance.vue?vue&type=style&index=0&id=80109a7a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80109a7a",
  null
  
)

export default component.exports